import * as Yup from 'yup';
import EN from '../../EN.json';
import FR from '../../FR.json';

const { 
  USERS: {
    BULK_FILE_UPLOAD: {
      NO_FILE_SELECTED
    }
  }
} =  localStorage.getItem('locale') ? (localStorage.getItem('locale') === 'EN' ? EN : FR) : EN;
const FileUplaodSchema = Yup.object().shape({
  registrationFile: Yup.string().required(NO_FILE_SELECTED)
});

export default FileUplaodSchema;